<div class="sidebar-layout">
  <div class="ds-global-navigation ds-global-navigation__sidebar">
    <ds-global-menu
      style="height: 100%;"
      class="menu"
      [navigationConfig]="myNavConfig"
      [activeLink]="myActiveLink"
      [navigationAriaLabel]="myNavAriaLabel"
      (onClickLink)="onSidebarClickLink($event)"
    ></ds-global-menu>
    <div
      class="ds-global-navigation__theme-switcher-container ds-dividers ds-dividers--thin ds-dividers--center_solid ds-dividers--horizontal ds-dividers--top"
    >
      <p class="ds-global-navigation__theme-label   ff-body-s ff-regular">
        {{ "sidenav.Tema" | translate }}
      </p>
      <ds-switch
        [attr.switch-states]="'two'"
        [attr.switch-icon-left]="'icon-moon'"
        [attr.switch-icon-right]="'icon-sun'"
        [attr.switch-size]="'small'"
        [attr.button-left-aria-label]="'switch to dark theme'"
        [attr.button-right-aria-label]="'switch to light theme'"
        [attr.checked-button]="switchThemeSide"
        switch-left-id="switchLeftThemeId"
        switch-right-id="switchRightThemeId"
        (onSwitchChange)="onSwitchChange($event)"
      ></ds-switch>
    </div>
  </div>
  <div class="sidebar-content">
    <div class="sidebar-content__main">
      <ng-content></ng-content>
    </div>
    <ng-content select="app-footer"></ng-content>
  </div>
</div>
